module.exports = __webpack_public_path__ + "static/media/DR1.7cde9c5f.webp";